import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import CaseStudySpotless from "@/pages/CaseStudySpotless";

export const Route = createFileRoute("/case-studies/spotless-polska")({
  head: () => routeHead("Spotless Polska case study — AGAPE", META_DESCRIPTIONS.spotless.en, "/case-studies/spotless-polska"),
  component: CaseStudySpotless,
});
